export const environment = {
  production: true,
  hostUrl: 'https://aquaflow.vitdev.com/',
  attachmentUrl: 'https://aquaflowapibeta.vitdev.com/',
  apiBaseUrl: 'https://aquaflowapibeta.vitdev.com/api/',
};
